import { useMutation } from '@tanstack/react-query';

import { decideApproval, type ApprovalItem, type DecideApprovalInput } from '../api/approvals.client.js';

export function useApprovalMutation() {
  return useMutation<ApprovalItem, Error, DecideApprovalInput>({
    mutationFn: decideApproval,
  });
}
